var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"animated-section",class:{ 'is-visible': _vm.isVisible, 'is-left': _vm.direction === 'left', 'is-right': _vm.direction === 'right' },style:({ transitionDelay: _vm.delay + 'ms' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }